
export const ADD_TO_COMPARE = 'ADD_TO_COMPARE';
export const DELETE_COMPARE = 'DELETE_COMPARE';
export const EMPTY_COMPARE = 'EMPTY_COMPARE'; 
export const USER_DETAIL = "USER_DETAIL";
export const ADD_TO_TRANSLATION = "ADD_TO_TRANSLATION";
export const LOGOUT = "LOGOUT";